import { Injectable } from '@angular/core';



export interface Module{
    id: string,
    title: string,
    price: number,
    idPlans: string
  }

@Injectable({
  providedIn: 'root'  
})
export class PaymentUtilitiesService {

    public cart: Module[]= [];
    public somma:number = 0;
    public priceString ='';


    constructor() { }

    

    //aggiunge il modulo al carrello
    public addToCart(id:string , title:string, idPlans: string, price: number, ): Module[]{
        let module: Module = {id, title, idPlans, price};
        this.cart.push(module);
        console.log('modules', this.cart);
        this.storeAmount(this.cart);
        return this.cart;
    }

    //elimina il modulo dal carrello
    public removeModule(id:string):Module[]{
        this.cart = this.cart.filter((module) => module.id != id);
        this.storeAmount(this.cart);
        return this.cart;
    }

    //Ritrona la somma del carrello
    public storeAmount(cart: Module[]):number{
        this.somma = 0;
        for(let i=0; i<cart.length; i++){ 
        this.somma += cart[i].price;
        }
        //Calcolo e addizione IVA
        this.somma = this.somma+(this.somma*0.22);
        return this.somma;
    }

    //Controlla se il modulo è già stato aggiunto al carrello, se si il tasto aggiungi sul 
    //componente viene disattivato
    public cartIsPresent(id:string):boolean{
        for(let i=0; i<this.cart.length; i++){
            if(this.cart[i].id == id){
            return true;
            }
        }
        return false;
    }
    
    //Funzione per formattare il prezzo
    public priceFormatter(price:number):string{
        this.priceString = price.toFixed(2);
        return this.priceString.replace('.',',')
    }

}
